// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"335b05ff","91":"5e7a075f","245":"4ca8f074","338":"f766139a","479":"280e9000","515":"29914248","688":"0704125f","710":"b4da6434","775":"0ba9a500","886":"280e9000","887":"46c5af16","960":"fc4e4af2"}[chunkId] + ".chunk.css";
};